<template>
    <!--Container-->
    <div :class="divClasses.container">

        <!--Control Select Document 🎛️-->
        <div :class="divClasses.forms">
            <label to="selector_document"> Seleccionar documento: </label>
            <select :class="divClasses.controls" name="selector_document" id="selector_document" v-model="documentSelected" @change="changeDocumentType()">
                <option v-for="(document, i) in documentList" :key="i" :value="document.key" > {{ document.type }}</option>
            </select>
        </div>
        <!--End Control Select Document-->

        <!--Control Select Multiple Document 🎛️-->
        <div v-show="multipleDocumentsList.length>0" :class="divClasses.forms">
            <label to="selector_multi_document"> Seleccionar nombre del documento: </label>
            <select :class="divClasses.controls" name="selector_multi_document" id="selector_multi_document" v-model="multipleDocumentsSelected" @change="changeMultipleDocumentsList()">
                <option v-for="(document, i) in multipleDocumentsList" :key="i" :value="document" > {{ document.type }}</option>
            </select>
        </div>
        <!--End Control Select Multiple Document-->

        <!--Control Download Document ⬇️-->
        <div v-show="documentSource && documentExtension != 'mp4'" :class="divClasses.form">
            <input type="button" value="Descargar documento" @click="download(documentSource, documentName)">
        </div>
        <!--End Control Download Document-->

        <!--Document Viewer 🎬,📷,📄-->
        <div v-if="documentExtension != ''" :class="divClasses.document">
            <div v-if="documentExtension == 'jpg' || documentExtension == 'jpeg' || documentExtension == 'png'" class="container_image">
                <img class="img_custom_class" v-bind:src="documentSource" :alt="documentAlt" >
            </div>
            
            <div v-if="documentExtension == 'mp4'" class="container_video">
                <video class="video_custom_class" :src="documentSource" controls />
            </div>
            
            <div v-if="documentExtension == 'mp4' && documentText != ''" class="document_description">
                <label class="document_label">Texto:</label>
                <p class="document_text">{{ documentText }}</p>
            </div>
            

            <div v-if="documentExtension == 'pdf'" class="container_embed">
                <embed class="embed_custom_class" :src="documentSource" width="600" height="700" alt="pdf_embed">
            </div>

            <div v-if="documentExtension == 'embed'" class="container_embed">
                <embed class="embed_custom_class" :src="documentSource" alt="video_embed">
            </div>
        
        </div>
        <!--End Document Viewer-->
    </div>
    <!--End Container-->
</template>

<script>

    import { toRef, ref } from 'vue';
    export default {
        name: "DocumentsViewer",
        props: {
            classes:{
                type: Object,
                default(){
                    return {
                        forms: '',
                        controls: '',
                        document: '',
                        container: ''
                    }
                }
            },
            document_list: {
                type: Array,
                default(){
                    return [];
                }
            },
            document_text: {
                type: String,
                default(){
                    return ""
                }
            }
        },
        setup(props){
           
            let divClasses = toRef(props, 'classes');
            let documentList = toRef(props, 'document_list');
            let documentText = toRef(props, 'document_text');

            let documentSelected = ref({});
            let multipleDocumentsSelected = ref({});
            let multipleDocumentsList = ref([]);

            let documentExtension = ref('');
            let documentSource = ref('');
            let documentName = ref('');

            function clearDocumentSelected(){
                multipleDocumentsSelected.value = {};
                multipleDocumentsList.value = [];
                documentExtension.value = '';
                documentSource.value = '';
                documentName.value = '';
            }

            function changeDocumentType(){
                clearDocumentSelected();

                if(checkExistenceOfmultipleDocumentsList(documentList.value, documentSelected.value)){
                    multipleDocumentsList.value = getMultipleDocumentsList(documentList.value, documentSelected.value);
                    return;
                }

                let information = getDocumentInformationByKey(documentList.value, documentSelected.value);
                if(!information){
                    return;
                }

                documentExtension.value =  information.extension;
                documentSource.value =  information.source;
                documentName.value = information.name;
            }

            function changeMultipleDocumentsList(){
                documentExtension.value =  multipleDocumentsSelected.value.extension;
                documentSource.value =  multipleDocumentsSelected.value.source;
                documentName.value = multipleDocumentsSelected.value.name;
            }

            function getDocumentInformationByKey(list, key){
                let document = list.find(element => element.key == key && !Array.isArray(element.content));
                if(!document){
                    return null;
                }

                return document.content;
            }

            function checkExistenceOfmultipleDocumentsList(list, key){
                let secondList = list.filter(element => {
                    if(element.key == key){
                        if(Array.isArray(element.content)){
                            return true;
                        }
                    }
                });
                
                return secondList.length>0;
            }

            function getMultipleDocumentsList(list, key){
                let secondList = list.find(element => {
                    if(element.key == key){
                        if(Array.isArray(element.content)){
                            return element.content;
                        }
                    }
                });

                return secondList.content;
            }

            function download(url, name){
                var link = document.createElement("a");
                link.setAttribute('download', name);
                link.href = url;
                document.body.appendChild(link);
                link.click();
                link.remove();
            }

            return {
                divClasses,
                documentList,
                multipleDocumentsList,
                multipleDocumentsSelected,
                documentSelected,
                changeDocumentType,
                changeMultipleDocumentsList,
                documentExtension,
                documentSource,
                download,
                documentName,
                documentText
            }
        }
    }
</script>